// Optical depth of the low haze along a view ray over a curved planet, for
// the terrain's fog chunk (environment.js) and the clouds (cloudshaders.js),
// so the ground and the clouds sit in one air out to the horizon.
//
// Along a ray the altitude is h0 + mu s + s^2 / 2R (mu the cosine of the
// ray's zenith angle at the camera), so the integral of exp(-h / H) is a
// Gaussian one. Written with erfcx(x) = exp(x^2) erfc(x) its exponentials
// reduce to the haze density at either end of the ray, which keeps it finite
// at any angle. Past about 30 km this is what matters: a ray from 12 km to
// the horizon meets the ground tangentially and skims the bottom of the haze
// for well over a hundred kilometres, an optical depth of about 3 where a
// flat ground gives 1.4. Nearer in the two agree, and the callers keep their
// flat closed form there. erfcx is a rational fit good to a few per cent.
export const AIR_DEPTH_GLSL = /* glsl */`
float airErfcx(float x) {
  return 1.1283792 / (x + sqrt(x * x + 1.2732395));
}
float airCurvedDepth(float h0, float mu, float L, float H) {
  const float R = 6371000.0;
  float sig = sqrt(2.0 * R * H);
  float h1 = h0 + L * mu + L * L / (2.0 * R);
  float b = R * mu / sig, a = (L + R * mu) / sig;
  float k = sqrt(1.5707963 * R * H);
  float e0 = exp(-max(h0, 0.0) / H), e1 = exp(-max(h1, 0.0) / H);
  if (b >= 0.0) return k * max(e0 * airErfcx(b) - e1 * airErfcx(a), 0.0);
  if (a <= 0.0) return k * max(e1 * airErfcx(-a) - e0 * airErfcx(-b), 0.0);
  // The ray passes its lowest point on the way: the density there, times
  // the Gaussian's mass either side of it.
  float hMin = max(h0 - R * mu * mu * 0.5, 0.0);
  float erfA = 1.0 - exp(-a * a) * airErfcx(a), erfB = 1.0 - exp(-b * b) * airErfcx(-b);
  return k * exp(-hMin / H) * (erfA + erfB);
}
`;
